import translationsSlice from 'modules/translations/reducer';

const actions = { ...translationsSlice.actions };

export default actions;
